import { FC, useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { AuthenticationContext } from '@vs-online-only-app/state';
import {
  IllustrationOffline,
  UpdateAssociateAvailabilityButton,
} from '@vs-online-only-app/ui';

const AssociateOfflinePlaceholder: FC = () => {
  const { user: associate } = useContext(AuthenticationContext);
  return (
    <Stack gap={2} alignItems="center">
      <IllustrationOffline />
      <Stack gap={1} alignItems="center">
        <Typography variant="h6">You're offline.</Typography>
        <Typography align="center" variant="body2">
          Go online to get notified when customers want to connect.
        </Typography>
      </Stack>
      {associate && (
        <UpdateAssociateAvailabilityButton
          variant="outlined"
          associate={associate}
          fullWidth
        />
      )}
    </Stack>
  );
};

export default AssociateOfflinePlaceholder;
